<template>
  <div class="
      onlineTest
      d-flex
      flex-column
      justify-content-center
      align-items-center
      pb-5
    ">
    <LoaderContent v-if="isLoading" :welcomeMessage="false" :alignSpinnerTop="false" />

    <div class="component-body-tests bg-white shadow-sm p-4 p-md-5 mt-5 w-100" v-for="(question, iq) in questions" :key="iq">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="text-secondary test-name">{{ test_name }}</h5>
        <Countdown class="" :time="timer" v-if="timer" />
      </div>

      <p class="current-question">Pergunta {{ question.order }} de {{ question.qtd_of_questions }}</p>

      <hr class="mb-4" />

      <b-tabs card no-nav-style nav-wrapper-class="d-none">
        <b-tab class="p-0">
          <h4 class="text-blue-ml font-weight-normal unselectable" v-html="question.question"></h4>
          <p class="description" v-html="question.description"></p>
          <div v-if="question.image != null" class="d-flex justify-content-center image-title">
            <img :src="question.image" />
          </div>

          <div v-if="question.is_movie">
            <div class="form-group mt-4">
              <label for="input-video">Entrevista em Video</label>
              <input class="form-control form-control-lg" type="url" v-model="url_movie" id="input-video" />
              <small id="emailHelp" class="form-text text-muted">Apenas vídeos do YouTube</small>
            </div>
          </div>

          <div v-else-if="question.is_text">
            <div class="form-group mb-4">
              <label for="text-answer">Preencha sua resposta no campo abaixo.</label>
              <textarea class="form-control form-control-lg" id="text-answer unselectable" rows="5" v-model="text_answer" :minlength="question.min_characters" :maxlength="question.max_characters"></textarea>
              <small class="form-text text-muted">{{ text_answer.length }}/{{ question.max_characters }}</small>
            </div>
          </div>

          <div v-else>
            <p class="select-x-options ">Selecione {{ question.required_answers }} {{ question.required_answers > 1 ? "opções" : "opção" }}</p>

            <div v-for="(option, io) in question.options">

              <label class="new-option-layout unselectable">
                <input :type="question.required_answers == 1 ? 'radio' : 'checkbox'" :id="option.id" :value="option.id" v-model="checkQuestion" />

                <span class="option-icon">
                  <check-icon />
                </span>

                {{option.option}}
                <img :src="option.image" />
              </label>

            </div>
            <small class="text-danger">{{ captionErrorMsg }}</small>

          </div>
        </b-tab>
      </b-tabs>
    </div>

    <div class="row mt-3" v-for="(question, iq) in questions">
      <div class="col-12 text-center">
        <button class="btn btn-light mr-3" @click="tabIndex--" v-show="tabIndex != 0">
          Voltar
        </button>

        <button v-if="question.link[0].next != undefined" class="btn btn-lg btn-blue-ml" @click="nextTab()">
          <span v-if="!isSaving">Próxima Pergunta</span>
          <EllipsisLoader v-else />
        </button>

        <button v-if="question.link[0].next == undefined" class="btn btn-lg btn-blue-ml" @click="nextTab()">
          <span v-if="!isSaving">Finalizar</span>
          <EllipsisLoader v-else />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EnhancedCheck,
  EnhancedCheckGroup,
  EnhancedCheckRadio,
  EnhancedToggle,
} from 'vue-enhanced-check';
import Vue from '../../../Vue';
import LoaderContent from '../Loader/LoaderContent.vue';
import EllipsisLoader from '../Loader/EllipsisLoader.vue';
import Countdown from '../Countdown/Countdown.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';

export default {
  name: 'ComponentOnlineTest',
  props: {
    headerTestId: String,
  },

  data() {
    return {
      isLoading: false,
      isSaving: false,
      tabIndex: 0,
      checkQuestion: [],
      url_movie: '',
      text_answer: '',
      test_name: '',
      timer: null,
      captionErrorMsg: null,
      questions: [
        {
          question: '',
          description: '',
          image: '',
          is_movie: false,
          options: [],
          link: [{ prev: '', next: '' }],
          order: '',
          required_answers: '',
          qtd_of_questions: '',
        },
      ],
    };
  },

  watch: {
    checkQuestion: function(newValue, oldValue){
      if(newValue.length > this.questions[0].required_answers){
        setTimeout(() => {
          this.captionErrorMsg = 'Máximo de opções já foi escolhido. Remove a seleção de alguma opção.'
        }, 100)

        this.checkQuestion = oldValue
      } else {
        this.captionErrorMsg = null;
      }
    }
  },

  mounted() {
    this.isLoading = true;

    // Valida se já respondeu a questão que está tentando acessar. Se sim, volta para Cover
    let testNavigation = localStorage.getItem('testNavigation');
    if (testNavigation) testNavigation = atob(testNavigation);
    testNavigation = JSON.parse(testNavigation) || {};

    if (
      testNavigation.answered == this.$route.path
      && testNavigation.can_edit == false
    ) {
      this.$router.push(testNavigation.cover_url);
      return;
    }

    this.$store
      .dispatch('tests/testQuestion', {
        headerTestId: this.$route.params.headerTestId,
        questionId: this.$route.params.first_question,
      })
      .then((questions) => {
        const test = questions.testQuestion.json.header_questions;

        this.test_name = test.header.test_name;

        this.questions[0].question = test.question.title;

        this.questions[0].description = test.question.description;

        this.questions[0].image = test.question.image;

        this.questions[0].is_movie = test.question.is_movie;

        this.questions[0].is_text = test.question.is_text;
        this.questions[0].min_characters = test.question.min_characters || 0;
        this.questions[0].max_characters = test.question.max_characters || 200;

        test.question.answer_options.forEach((element, index) => {
          this.questions[0].options[index] = element;
        });

        this.questions[0].link[0].next = test.links.next;

        this.questions[0].link[0].prev = test.links.prev;

        this.questions[0].order = test.question.order;

        this.questions[0].required_answers = test.question.required_answers;

        this.questions[0].qtd_of_questions = test.header.qtd_of_questions;

        this.timer = test.header.time_to_finish;

        this.isLoading = false;
      })
      .catch((error) => {
        this.$swal(
          'Uoops',
          'Ocorreu um erro ao carregar a pergunta. Tente novamente...',
          'error',
        ).then(() => {
          this.isLoading = false;
          this.$router.push(`/vagas/${this.$route.params.id}/inscricao/testes`);
        });
      });
  },

  computed: {
    opportunityId() {
      const id = this.$route.params.id.match(/\d+/)[0];
      return id;
    },
  },

  components: {
    LoaderContent,
    EllipsisLoader,
    EnhancedCheck,
    EnhancedCheckGroup,
    EnhancedCheckRadio,
    EnhancedToggle,
    Countdown,
    CheckIcon
  },

  methods: {
    nextTab() {
      const { required_answers } = this.$data.questions[0];

      if (this.questions[0].is_movie) {
        if (
          /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)\&?/.test(
            this.url_movie,
          ) == false
        ) {
          this.$swal('Uoops', 'Insira apenas vídeo do YouTube', 'error');
        } else {
          this.checkQuestion = this.questions[0].options[0].id;
          this.saveForm();
        }
      } else if (this.questions[0].is_text) {
        if (this.text_answer.length == 0
            || this.text_answer.length < this.questions[0].min_characters
            || this.text_answer.length > this.questions[0].max_characters) {
          this.$swal('Uoops', `Sua resposta deve conter entre ${this.questions[0].min_characters} e ${this.questions[0].max_characters} caracteres`, 'error');
        } else {
          this.checkQuestion = this.questions[0].options[0].id;
          this.saveForm();
        }
      } else {
        if (!Array.isArray(this.checkQuestion)) {
          this.checkQuestion = [this.checkQuestion]
        }

        if (this.checkQuestion.length != required_answers){
          this.$swal('Uoops', `Selecione ${required_answers} ${required_answers == 1 ? 'opção' : 'opções'}`, 'error');
        } else {
          this.saveForm();
        }
      }
    },

    toSeconds(time_left) {
      const [hours, minutes, seconds] = time_left.split(':').map(Number);      
      return (hours * 3600) + (minutes * 60) + seconds;
    },

    saveForm() {
      this.isLoading = true;
      this.isSaving = true;
      const countdown = document.querySelectorAll('.countdown')[0];
      const time_left = countdown ? countdown.innerText : null;

      const { next } = this.$data.questions[0].link[0];

      const headerTest = this.$route.params.headerTestId;

      const questionId = this.$route.params.first_question;

      const url = `${Vue.prototype.PLATFORM_TEST}/v1/header/${headerTest}/questions/${questionId}`;
      this.$store
        .dispatch('tests/saveTestQuestion', {
          url,
          answers: this.checkQuestion,
          text_answer: this.text_answer,
          url_movie: this.url_movie,
          time_to_finish: time_left ? this.toSeconds(time_left) : null,
        })
        .then((response) => {
          this.isLoading = false;
          this.isSaving = false;

          if (response.error) {
            this.$swal(
              'Uoops',
              'Ocorreu um erro ao salvar suas informações',
              'error',
            );
          } else {
            this.$store.commit('tests/SET_TEST_NAVIGATION_CONTROL', {
              answered: this.$route.path,
            });

            if (time_left && this.toSeconds(time_left) <= 0) {
              this.$swal('Uoops', 'Tempo esgotado!', 'error');
              this.$router.push({
                name: 'testes',
              });
            }

            if (next != undefined) {
              const nextQuestionId = next.match(/\d+/g, ' ')[3];
              this.$router.push({ params: { first_question: nextQuestionId } });
            } else if (window.afterTestBackTo) {
              this.$router.push(window.afterTestBackTo);
              delete window.afterTestBackTo;
            } else if (window.challengeBackTo) {
              this.$router.push(window.challengeBackTo);
            } else {
              this.$router.push(
                `/vagas/${this.$route.params.id}/inscricao/testes`,
              );
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .new-option-layout{
    width: 100%;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    display: inline-flex;
    align-items: center;

    label {
      margin: 0;
    }

    input{
      position: absolute;
      left: -15px;
      top: -15px;
      opacity: 0;
    }

    input:checked + .option-icon{
      background: theme-color('primary');
      span{
        display: flex;
      }
    }

    .option-icon{
      content: "";
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 1px solid #eee;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      flex-shrink: 0;

      span{
        display: none;
        color: #fff;
      }
    }
  }

  .unselectable {
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
}
</style>
